import { render, staticRenderFns } from "./SearchEmployment.vue?vue&type=template&id=081dc920"
import script from "./SearchEmployment.vue?vue&type=script&lang=ts"
export * from "./SearchEmployment.vue?vue&type=script&lang=ts"
import style0 from "./SearchEmployment.vue?vue&type=style&index=0&id=081dc920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports